import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'environments/environment';
import { FormGroup, FormControl, Validators } from '@angular/forms';

interface RoadBlock{
  link: string,
  image: any,
  imagePath: any,
  status: boolean
}

@Component({
  selector: 'app-edit-road-block',
  templateUrl: './edit-road-block.component.html',
  styleUrls: ['./edit-road-block.component.css']
})
export class EditRoadBlockComponent{

  advertisementForm = new FormGroup({
    link: new FormControl('', [Validators.required]),
    status: new FormControl('', [Validators.required]),
    image: new FormControl(null)
  })

  constructor(
    public dialogRef: MatDialogRef<EditRoadBlockComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RoadBlock) {
      let advertisementInstance = Object.assign({}, data)
      delete advertisementInstance['imagePath']
      this.advertisementForm.setValue(advertisementInstance)
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  fileChangeEvent(event: any){
    let image = event.target.files[0]
    this.advertisementForm['controls']['image'].setValue(image)
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]); 
    reader.onload = (_event) => { 
      this.data.imagePath = reader.result; 
    }
  }

  saveAd(){
    console.log(this.advertisementForm.value)
    if(this.advertisementForm.valid){
      this.dialogRef.close(this.advertisementForm.value)
    }
  }

}
